// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"131":"7c5e5970","220":"e974cb91","366":"c924bfac","367":"fd93e4ec","784":"a7497ad3","867":"5229f94e","916":"b34b9e26"}[chunkId] + ".js";
};